import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Chip,
} from '@mui/material';
import {
  Instagram as InstagramIcon,
  PlayCircleOutline as PlayIcon,
  Groups as GroupsIcon,
  AttachMoney as MoneyIcon,
  CalendarMonth as CalendarIcon,
} from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

const testimonies = [
  {
    name: 'Priamo Persichetti',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/430e284f-c168-4740-aaec-fe764359a114/IMG_5329.png',
    periodKey: 'period1',
    families: 45,
    deposit: '$93,716',
    reel: 'https://www.instagram.com/reel/DM8HF6kssma/?igsh=MWRxaXM5NGxqd2l5cA==',
  },
  {
    name: 'Nick Scancarello',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/9f87ae0b-6b0e-41c5-9225-cf5155b59adf/IMG_5324.png',
    periodKey: 'period2',
    families: 6,
    deposit: '$8,086',
    reel: 'https://www.instagram.com/reel/DN_KxZhjYGT/?igsh=MWJyNDFkeDhjd3N4bw==',
  },
  {
    name: 'Jamie Caldwell',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/cb5265f4-39bc-47a7-aadd-78eb50a6d6ed/IMG_5326.png',
    periodKey: 'period3',
    families: 25,
    deposit: '$26,361',
    reel: 'https://www.instagram.com/reel/DNdbsygNebf/?igsh=MWJ5MXlvcTlxeXYwNQ==',
  },
  {
    name: 'Cole Brayton',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/27c3fd66-de7f-4eda-a6fe-985611638e67/IMG_5323.png',
    periodKey: 'period4',
    families: 10,
    deposit: '$11,657',
    reel: 'https://www.instagram.com/reel/DOmEuvegS9u/?igsh=OWM0OTZrZnp5ZTN1',
  },
  {
    name: 'Ashley Seborowski',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/c823a6d0-8e1d-4bf2-94e5-b385de7e82bd/IMG_A8061F7D69AB-1.jpg',
    periodKey: 'period5',
    families: 30,
    deposit: '$19,000',
    reel: 'https://www.instagram.com/reel/DNg3G-ihxUm/?igsh=MWNvdHAzbWV5dHQyYQ==',
  },
  {
    name: 'Teeshan Udayakumar',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/7b086279-6357-431c-9ef9-6da5eb549c04/IMG_5315.png',
    periodKey: 'period6',
    families: 10,
    deposit: '$9,646',
    reel: 'https://www.instagram.com/reel/DOzb7VKjIV4/?igsh=MTU5bzJ3cWp1YW5uYQ==',
  },
  {
    name: 'Nate Tubbs',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/c90161b8-e50c-4151-b0b1-ae74a2792661/IMG_5321.png',
    periodKey: 'period7',
    families: 30,
    deposit: '$32,000',
    reel: 'https://www.instagram.com/reel/DOvucTIja4o/?igsh=cGw0OTJ2bnI5djYw',
  },
  {
    name: 'Isabella Renaldi',
    image: 'https://images.squarespace-cdn.com/content/v1/67216bb59809fa4deecb6d4c/1f2112e6-769c-4773-a5fb-06db0d1331cb/IMG_5328.png',
    periodKey: 'period8',
    families: 10,
    deposit: '$12,000',
    reel: 'https://www.instagram.com/reel/DNGv3kaOEae/?igsh=b2ozcmp1bTNrOTQz',
  },
];

const Testimonies = () => {
  const { t } = useTranslation();

  return (
    <Container maxWidth="md" sx={{ py: 2 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
        {t('testimonies.title')}
      </Typography>
      <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
        {t('testimonies.subtitle')}
      </Typography>

      {/* Instagram CTA */}
      <Card
        sx={{
          mb: 4,
          background: 'linear-gradient(135deg, #1F6F52 0%, #2C9C6C 100%)',
          color: 'white',
        }}
      >
        <CardContent sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2, py: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <InstagramIcon sx={{ fontSize: 40 }} />
            <Box>
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {t('testimonies.instagramTitle')}
              </Typography>
              <Typography variant="body2" sx={{ opacity: 0.9 }}>
                {t('testimonies.instagramSubtitle')}
              </Typography>
            </Box>
          </Box>
          <Button
            variant="contained"
            href="https://www.instagram.com/equityinsurancepartners"
            target="_blank"
            rel="noopener noreferrer"
            sx={{
              bgcolor: 'white',
              color: '#2C9C6C',
              fontWeight: 600,
              '&:hover': { bgcolor: 'rgba(255,255,255,0.9)' },
            }}
            startIcon={<InstagramIcon />}
          >
            @Equityinsurancepartners
          </Button>
        </CardContent>
      </Card>

      {/* Testimony Cards */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        {testimonies.map((testimony) => (
          <Card key={testimony.name} sx={{ overflow: 'visible' }}>
            <CardContent sx={{ p: 3 }}>
              <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start', flexDirection: { xs: 'column', sm: 'row' } }}>
                {/* Avatar */}
                <Avatar
                  src={testimony.image}
                  alt={testimony.name}
                  sx={{
                    width: 100,
                    height: 100,
                    border: '3px solid #2C9C6C',
                    alignSelf: { xs: 'center', sm: 'flex-start' },
                    bgcolor: '#2C9C6C',
                    fontSize: '2rem',
                    fontWeight: 700,
                  }}
                >
                  {testimony.name.split(' ').map(n => n[0]).join('')}
                </Avatar>

                {/* Content */}
                <Box sx={{ flex: 1, width: '100%' }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                    {testimony.name}
                  </Typography>

                  {/* Stats */}
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.5, mb: 2 }}>
                    <Chip
                      icon={<CalendarIcon sx={{ fontSize: 18 }} />}
                      label={t(`testimonies.${testimony.periodKey}`)}
                      size="small"
                      sx={{
                        bgcolor: 'rgba(44, 156, 108, 0.08)',
                        color: '#2C9C6C',
                        fontWeight: 500,
                        '& .MuiChip-icon': { color: '#2C9C6C' },
                      }}
                    />
                    <Chip
                      icon={<GroupsIcon sx={{ fontSize: 18 }} />}
                      label={t('testimonies.familiesProtected', { count: testimony.families })}
                      size="small"
                      sx={{
                        bgcolor: 'rgba(77, 200, 150, 0.08)',
                        color: '#4DC896',
                        fontWeight: 500,
                        '& .MuiChip-icon': { color: '#4DC896' },
                      }}
                    />
                    <Chip
                      icon={<MoneyIcon sx={{ fontSize: 18 }} />}
                      label={t('testimonies.deposited', { amount: testimony.deposit })}
                      size="small"
                      sx={{
                        bgcolor: '#c9a84c20',
                        color: '#a88a35',
                        fontWeight: 600,
                        '& .MuiChip-icon': { color: '#a88a35' },
                      }}
                    />
                  </Box>

                  {/* Watch Button */}
                  {testimony.reel && (
                    <Button
                      variant="outlined"
                      size="small"
                      href={testimony.reel}
                      target="_blank"
                      rel="noopener noreferrer"
                      startIcon={<PlayIcon />}
                      sx={{
                        borderColor: '#2C9C6C',
                        color: '#2C9C6C',
                        fontWeight: 500,
                        '&:hover': {
                          borderColor: '#4DC896',
                          bgcolor: 'rgba(44, 156, 108, 0.03)',
                        },
                      }}
                    >
                      {t('testimonies.watchTestimony')}
                    </Button>
                  )}
                </Box>
              </Box>
            </CardContent>
          </Card>
        ))}
      </Box>
    </Container>
  );
};

export default Testimonies;
